import { APPLICATION_NAME, CLIENT_NAME } from './CONSTANT';
import { saveState } from './LocalStorage';
import { getURLParameter } from './nativeSupport';

export const isProd = (): boolean => process.env.NODE_ENV === 'production';

export const isIOS = (): boolean => {
	return (
		['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
		// iPad on iOS 13 detection
		(navigator.userAgent.includes('Mac') && 'ontouchend' in document)
	);
};

export const showTwelvePcUI = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'application');
	const applicationName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('applicationName', applicationName, true);
	return applicationName === APPLICATION_NAME.TPCLUB;
};

export const showPostPeUI = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'application');
	const applicationName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('applicationName', applicationName, true);
	return applicationName === APPLICATION_NAME.POSTPE;
};

export const showZillionUi = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'application');
	const applicationName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('applicationName', applicationName, true);
	return applicationName === APPLICATION_NAME.ZILLION;
};

export const showUnityUi = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'application');
	const applicationName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('applicationName', applicationName, true);
	return applicationName === APPLICATION_NAME.UNITY_BANK;
};

export const isSwipeClient = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'clientName');
	const clientName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('clientName', clientName, true);
	return clientName === CLIENT_NAME.BHARAT_SWIPE;
};

export const showSurcharge = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'clientName');
	const clientName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('clientName', clientName, true);
	return [CLIENT_NAME.DEPOSIT, CLIENT_NAME.TPCLUB_ADD_MONEY].includes(clientName);
};
